module.exports = __webpack_public_path__ + "img/icon_chip_05.318cba8f.png";